import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import {getBaseUrl, val} from '../util/HelpfulFunctions';
import SessionManager from '../util/SessionManager';


const defaultProfileImg = getBaseUrl() + "/assets/user-profile.svg";

class UserAccountMenu extends Component {

    constructor(props) {
        super(props);

        if (props) {
            this.state = {
                loginRoute: val(props.loginRoute, "/login"),
                logoffRoute: val(props.logoffRoute, "/"),
                profilePicture: val(props.profilePicture, defaultProfileImg)
            };
        }

    }

    render() {

        const logoffMenu = (
            <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center" href="!#" onClick={this.logout}>
                <div className="preview-thumbnail">
                    <i className="mdi mdi-logout text-primary"></i>
                </div>
                <div className="preview-item-content py-2">
                    <Trans>Αποσύνδεση</Trans>
                </div>
            </Dropdown.Item>
        );


        const logonMenu = (
            <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center" href="!#" onClick={this.login}>
                <div className="preview-thumbnail">
                    <i className="mdi mdi-logout text-primary"></i>
                </div>
                <div className="preview-item-content py-2">
                    <Trans>Σύνδεση</Trans>
                </div>
            </Dropdown.Item>
        );


        var userDescr = SessionManager.userDescription();

        return (
            <div className="d-flex">
                
                <div className="desktop text-muted my-auto text-truncate font-weight-medium mx-3">{userDescr}</div>
                <div className="mobile text-muted my-auto text-truncate font-weight-medium ml-0 mr-3">{userDescr.length > 17 ? userDescr.substring(0, 17) + "\u2026" : userDescr}</div>
                
                <Dropdown>
                    <Dropdown.Toggle className="nav-link count-indicator bg-transparent">
                        <img className="img-xs color-primary mx-1 bg-content rounded-circle"
                            src={this.state.profilePicture}
                            alt="Profile" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="preview-list navbar-dropdown ">

                        {this.renderAccountInfoMenu()}

                        <div className="dropdown-divider"></div>

                        {SessionManager.isUserLoggedIn ? logoffMenu : logonMenu}

                    </Dropdown.Menu>

                </Dropdown>
            </div>
        );
    }

    renderAccountInfoMenu() {
        if (SessionManager.isUserAdmin)
            return (<div />);

        return (
            <Dropdown.Item className="dropdown-item preview-item d-flex align-items-center" onClick={() => this.navigateTo("/accountManagement")}>
                <div className="preview-thumbnail">
                    <i className="mdi mdi-account-outline text-primary"></i>
                </div>
                <div className="preview-item-content py-2">
                    <Trans>Στοιχεία λογαριασμού</Trans>
                </div>
            </Dropdown.Item>
        )
    }

    logout() {
        SessionManager.logout();
        return ( <Redirect to={this.state.logoffRoute ? this.state.logoffRoute : "/"} /> );
    }

    login() {
        return ( <Redirect to={this.state.loginRoute ? this.state.loginRoute :  "/login"} /> );
    }

    navigateTo(path) {
        this.props.history.push(path);
      }
}

export default withRouter(UserAccountMenu);